import React from 'react'
import axios from 'axios'

class ITS extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: [],
			readyToSave: false,
			changesSaved: false,
			message: ''
		}
	}

	componentDidMount(){
		this.fetchData(this.props.id)
	}

	fetchData(id){
		axios.get('https://dhsetheatre-api.madebypeppernet.com//api-admin.php', {
			params: {
				filename: 'its',
				preview: true,
			}
		}).then( response => {
			this.setState({
				...this.state,
				headline: response.data.headline,
				content: response.data.content,
			})
		})
	}

	handleSaveChanges(){
		const params = new URLSearchParams()
		params.append('filename', 'its')
		params.append('headline', this.state.headline)
		params.append('content', this.state.content)
		params.append('isDraft', 1)

		axios({
			method: 'POST',
			url: 'https://dhsetheatre-api.madebypeppernet.com//api-admin.php',
			headers: { 'Content-type': 'application/x-www-form-urlencoded' },
			data: params,
		})
		.then( () => {
			this.setState({
				readyToSave: false,
				changedSaved: true,
				message: 'Preview Saved'
			})
		})
	}

	handleSubmit(e){
		// Kill default functionality.
		e.preventDefault()
		return false
	}

	handleUpdate(form){
		this.setState({
			...this.state,
			headline: encodeURIComponent(form.querySelector('.headline').value),
			content: encodeURIComponent(form.querySelector('.content').value),
			readyToSave: true,
		})
	}

	render() {
		return (
			<section className="container edit">
				<h2>ITS</h2>
				{ this.state.readyToSave ?
						<button className="save button" onClick={this.handleSaveChanges.bind(this)}>Save Preview</button> :
						null
				}
				{
					this.state.message.length ?
						<p className="message">{this.state.message}</p> :
						null
				}
				<form
					className="itemContainer"
					onChange={ e => {this.handleUpdate(e.target.closest('form'))} }
					onSubmit={() => this.handleSubmit()}>
						<input
						type="text"
						value={this.state.headline ? decodeURIComponent(this.state.headline) : ''}
						placeholder="Title"
						className="headline" />
					<textarea
						value={this.state.content ? decodeURIComponent(this.state.content) : ''}
						placeholder="Content"
						className="content"></textarea>
				</form>
			</section>
		)
	}
}

export default ITS



// WEBPACK FOOTER //
// ./src/pages/its.js